import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ButtonFunction } from '@snack-uikit/button';
import { Divider } from '@snack-uikit/divider';
import { useLocale } from '@snack-uikit/locale';
import { TruncateString } from '@snack-uikit/truncate-string';
import { useNewListContext } from '../../components/Lists/contexts';
import { SELECT_BUTTON_SIZE_MAP } from './constants';
import styles from './styles.module.css';
export function Separator({ label, truncate, divider, mode = 'secondary', selectButton }) {
    const { size = 's' } = useNewListContext();
    const { t } = useLocale('List');
    const selectButtonJSX = useMemo(() => {
        if (!selectButton) {
            return null;
        }
        const { onClick, checked, itemRef } = selectButton;
        return (_jsx("span", { className: styles.selectButton, "data-size": size, "data-weight": (divider && mode) || undefined, children: _jsx(ButtonFunction, { size: SELECT_BUTTON_SIZE_MAP[size], tabIndex: 0, onClick: e => {
                    onClick === null || onClick === void 0 ? void 0 : onClick(e);
                    e.preventDefault();
                    e.stopPropagation();
                }, onFocus: e => {
                    e.stopPropagation();
                }, ref: itemRef, label: checked ? t('groupSelectButton.reset') : t('groupSelectButton.select') }) }));
    }, [divider, mode, selectButton, size, t]);
    if (label) {
        return (_jsxs("div", { className: styles.separatorWithLabel, "data-size": size, children: [_jsx("span", { className: styles.label, "data-mode": mode, children: _jsx(TruncateString, { variant: truncate === null || truncate === void 0 ? void 0 : truncate.variant, text: label, maxLines: 1 }) }), _jsxs("div", { style: { flex: 1 }, children: [selectButtonJSX, divider && _jsx(Divider, { weight: mode === 'primary' ? 'regular' : 'light', className: styles.divider })] })] }));
    }
    if (divider) {
        return (_jsx("div", { className: styles.separatorWithoutLabel, "data-size": size, children: _jsx(Divider, { weight: 'regular' }) }));
    }
    return null;
}
